export default "__VITE_PUBLIC_ASSET__af96c8ac__"